import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { type GameLogDto } from '@mafia/core';
import { api, ApiError } from '@/lib/api';
import { formatDate, teamName } from '@/lib/format';
import { Alert, Badge, Card, PageSpinner } from '@/components/ui';
import { MatchTimeline } from '@/components/MatchTimeline';
import { KindBadge } from '@/components/Kind';
import { ParticipantsTable } from './admin/ParticipantsTable';

/** Итоги и полная история партии — для её участников после окончания. */
export function GameResultPage() {
  const { id = '' } = useParams();
  const game = useQuery({ queryKey: ['game', id, 'log'], queryFn: () => api<GameLogDto>(`/api/games/${id}/log`) });

  if (game.isLoading) return <PageSpinner />;
  if (game.isError) {
    const msg = game.error instanceof ApiError ? game.error.message : 'Не удалось загрузить игру';
    return (
      <div className="mx-auto max-w-md px-4 py-16">
        <Alert>{msg}</Alert>
      </div>
    );
  }
  const g = game.data!;
  return (
    <div className="mx-auto max-w-4xl space-y-4 px-4 py-6 sm:py-10">
      <div>
        <p className="text-sm text-zinc-500">
          {g.roomName ?? 'Комната удалена'} · {formatDate(g.startedAt)}
        </p>
        <h1 className="mt-1 font-display text-3xl">
          {g.status === 'ABORTED' ? 'Игра прервана' : g.winner === 'DRAW' ? 'Ничья' : `Победа: ${g.winner ? teamName[g.winner] : '—'}`}
        </h1>
        <div className="mt-2 flex gap-2">
          <KindBadge kind={g.kind} showAmateur />
          <Badge>{g.playerCount} игроков</Badge>
          <Badge>{g.daysPlayed} дн.</Badge>
          {g.moderatorNickname && <Badge tone="gold">ведущий: {g.moderatorNickname}</Badge>}
        </div>
      </div>
      <Card className="overflow-hidden">
        <ParticipantsTable participants={g.participants} />
      </Card>
      <MatchTimeline game={g} />
    </div>
  );
}
